export default "__VITE_ASSET__258a5fb5__"